import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mi0505',
    ecrans: ['00-2']
});
